import { render, staticRenderFns } from "./customerService.vue?vue&type=template&id=91db03b4&"
import script from "./customerService.vue?vue&type=script&lang=js&"
export * from "./customerService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports